/**
 * @author NikolaV
 */

import * as React from 'react';
import './StatsMapPopups.scss';
import { MaterialStatsTable } from '../stats/MaterialStatsTable';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { StatsStore } from '@pages/trucks/store/StatsStore';
import { FilterStore } from '@pages/trucks/store/FilterStore';
import { DateUtils } from '@shared/utils/DateUtils';
import { observer } from 'mobx-react';
import { DateSpan } from '@shared/ui-react/UtilComponents';
import { GeofenceType } from '@shared/trucks/GeofenceFeatureFactory';


export function getGeofencePopupAsHtml(geofence, callback: (html: string) => void) {
    const Component = <StatsGeofenceMapPopups geofence={geofence}/>;
    return ReactUtils.renderToString(Component, null, callback);
}

/*export function getVehiclePopupAsHtml(vehicle, mapWrapper, callback: (html: string) => void) {
    const Component = <StatsVehicleMapPopups vehicle={vehicle} mapWrapper={mapWrapper}/>;
    return ReactUtils.renderToString(Component, null, callback);
}*/


@observer
export class StatsGeofenceMapPopups extends React.Component<{
    geofence: IGeofence
}> {
    statsFilter: FilterStore = new FilterStore();
    statsStore: StatsStore = new StatsStore(this.statsFilter);

    componentDidMount() {
        this.statsFilter.setFromStoresData();
        this.statsFilter.selectNone();
        this.statsFilter.setDates(DateUtils.TODAY_START, DateUtils.TODAY_END, null);
        this.statsFilter.focusArea(this.props.geofence.id, false);
        this.statsStore.fetch();
    }

    render() {
        const { geofence } = this.props;
        let stats = [];

        if (geofence.type == GeofenceType.LOAD) {
            stats = this.statsStore.items.filter(i => i.loadAreaId == geofence.id);
        }
        else if (geofence.type == GeofenceType.UNLOAD) {
            stats = this.statsStore.items.filter(i => i.unloadAreaId == geofence.id);
        }
        else if (geofence.type == GeofenceType.HYBRID) {
            stats = this.statsStore.items.filter(i => i.loadAreaId == geofence.id || i.unloadAreaId == geofence.id);
        }

        const summary = this.statsStore.groupByTimeAndMaterials(stats, 'all');

        return (
            <div className='geofence-map-popup stats-for-dates'>
                <div style={{ color: 'black', fontSize: 14, borderBottom: '1px solid #ccc', padding: '6px 0' }}>
                    <strong>{geofence.title}</strong>
                    {!!geofence.materials.length && <div>
                        {__('trucks.geofence.materials')}: {geofence.materials.map((material, i) =>
                        material.material + (geofence.materials.length > i + 1 ? ', ' : '')
                    )}
                    </div>}
                    <div>
                        <DateSpan timestamp={this.statsFilter.fromTimestamp}/> - <DateSpan timestamp={this.statsFilter.toTimestamp}/>
                    </div>
                </div>

                <MaterialStatsTable stats={summary} groupedBy={'all'}/>
            </div>
        );
    }
}

/*@observer
export class StatsVehicleMapPopups extends React.Component<{
    vehicle: ITruck,
    mapWrapper: MapWrapper
}> {
    statsFilter: FilterStore = new FilterStore();
    statsStore: StatsStore = new StatsStore(this.statsFilter);

    state = {
        posE: null,
        posN: null,
    };

    componentDidMount() {
        this.statsFilter.setFromStoresData();
        this.statsFilter.selectNone();
        this.statsFilter.setDates(DateUtils.TODAY_START, DateUtils.TODAY_END, 1);
        this.statsFilter.focusVehicle(this.props.vehicle.id, false);
        this.statsStore.fetch();

        Ajax({
            url : 'api/1/project/' + kuura.getProjectId() + '/convert_lat_lon.json',
            data: {
                lat: this.props.vehicle.position.latitude,
                lon: this.props.vehicle.position.longitude
            }
        }).done(resp => {
            this.setState({
                posE: resp.coords.e.toFixed(2),
                posN: resp.coords.n.toFixed(2)
            });
        });

        this.drawPositionTrail();
    }

    componentWillUnmount(): void {
        const vehiclesLayerWrapper = this.props.mapWrapper.featureLayers.vehicles;
        vehiclesLayerWrapper.clearPositionTrail();
    }

    drawPositionTrail = () => {
        this.props.mapWrapper.featureLayers.vehicles.drawPositionTrail(this.props.vehicle.id)
    }

    render() {
        const { vehicle } = this.props;
        const stats = this.statsStore.items.filter(i => i.vehicleId == vehicle.id);
        const summary = this.statsStore.groupByTimeAndMaterials(stats, 'all');

        return (
            <div className='geofence-map-popup stats-for-dates'>
                <div style={{ color: 'black', fontSize: 14, borderBottom: '1px solid #ccc', padding: '6px 0' }}>
                    <div>
                        <header>{vehicle.name}</header>
                        <div>{__('tablet.driver_js')}: {vehicle.driverName || '/'}, {__('tablet.gsm_js')}: {vehicle.driverPhone || '/'}</div>
                        <a style={{ textDecoration: 'underline' }} href={`vehicles.htm#/overview/${vehicle.id}`}
                           target='_blank'>{__('tablet.vehiclepage_js')}</a>
                    </div>

                    <section>
                        <div>lat: {vehicle.position.latitude}, lon: {vehicle.position.longitude}</div>
                        <div>n: {this.state.posN}, e: {this.state.posE}</div>
                        <div>{__('tablet.position_timestamp_js')}: <DateTimeSpan timestamp={vehicle.position.timestamp}/></div>
                        <div>{vehicle.reportAlert && __('tablet.vehicle_old_report_js')}</div>
                    </section>

                    <section>
                        <DateRangePicker store={this.statsFilter}
                                         clearable={true}
                                         onChange={(from, to, presetIndex) => {
                                             this.statsFilter.setDates(from, to, presetIndex);
                                             this.statsStore.fetch();
                                         }}/>
                    </section>
                </div>

                <MaterialStatsTable stats={summary} groupedBy={'all'}/>
            </div>
        );
    }
}*/
